import { Dispatch, useEffect} from "react";
import { AssessmentMode, IADPState, NetworkConnectionState, actions } from "../state";
import {IADPActions, IADPHeaderActions } from "../state/Actions";
const logPrefix = "[ADPClient][NetworkServiceHook]"

function checkNetworkState(networkConnectionState:NetworkConnectionState,selectedAssessmentMode:AssessmentMode){
  
  if(networkConnectionState==="offline"){
    if(selectedAssessmentMode=== "online"){
      return "NoInternetConnectionDetected";
    }
    else if(selectedAssessmentMode=== "ncs"){
     return "NoRouterConnectionDetected";
    }
  }
  else if (networkConnectionState==="online" && selectedAssessmentMode=== "ncs"){
    return "NoRouterConnectionDetected";

  }
  else if (networkConnectionState==="router" && selectedAssessmentMode=== "online"){
   return "NoInternetConnectionDetected";
  }
  return undefined;

}

export function useNetworkService(dispatchToApp: Dispatch<IADPActions>,state: IADPState,dispatch?: Dispatch<IADPHeaderActions>,) {
  
   async function getNetworkState() {
    //check if network state object is available, will be set by Electron or Chrome extension as part of greeting
    if(state.appState.runtimePlatform.platform ==="Electron" && state.sessionState.networkConnectionState){
      console.log("[ADpClient][useNetworkService] resovling network connection state from Electron",state.sessionState.networkConnectionState);
      if(dispatch)dispatch(actions.createSetNetworkAction(state.sessionState.networkConnectionState as NetworkConnectionState));
      const onNetworkStateChange = (event: any)=>{
       console.log("onNetworkStateChange",event.detail.message[0])
       if(dispatch)dispatch(actions.createSetNetworkAction(event.detail.message[0].connectionType as NetworkConnectionState));
       dispatchToApp(actions.createSetNetworkAction(event.detail.message[0].connectionType as NetworkConnectionState))
      
      };
      window.addEventListener('network-state-changed', onNetworkStateChange);
      return;
    }
    const networkState:NetworkConnectionState = window.navigator.onLine ? "online" : "offline";
    console.log("[ADpClient][useNetworkService] resovling network connection state based on web APIs",networkState);
    if(dispatch)dispatch(actions.createSetNetworkAction(networkState));
    dispatchToApp(actions.createSetNetworkAction(networkState));
    window.addEventListener("offline", (e) => {
      console.log(logPrefix,"device is offline");
      //TODO - combine into one action
      if(dispatch)dispatch(actions.createSetNetworkAction("offline"));
      dispatchToApp(actions.createSetNetworkAction("offline"));
      dispatchToApp(actions.createWarningAction("NoInternetConnectionDetected"));
    });
    window.addEventListener("online", (e) => {
      console.log(logPrefix,"device is offline");
      if(dispatch)dispatch(actions.createSetNetworkAction("online"));
      dispatchToApp(actions.createSetNetworkAction("online"));
    });
};
  
  useEffect(() => {
    getNetworkState();
  }, []);
};

export {checkNetworkState}

